var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearState } from '../../context/reducers/userReducer';
import { clearTokenLogout } from '../../utils/commonUtil';
const useInactivityTimeout = (timeout = 60 * 60 * 1000) => {
    const dispatch = useDispatch();
    let timeoutId;
    const resetTimeout = () => {
        if (timeoutId)
            clearTimeout(timeoutId);
        timeoutId = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            dispatch(clearState());
            yield clearTokenLogout();
        }), timeout);
    };
    useEffect(() => {
        const events = ['mousemove', 'keydown', 'click', 'scroll'];
        events.forEach((event) => window.addEventListener(event, resetTimeout));
        resetTimeout();
        return () => {
            clearTimeout(timeoutId);
            events.forEach((event) => window.removeEventListener(event, resetTimeout));
        };
    }, [dispatch, timeout]);
    return null;
};
export default useInactivityTimeout;
